import { useTranslation } from 'react-i18next'
import BookThumbnail from 'features/cart/components/ProductSummarySegment/ProductThumbnail/BookThumbnail'
import { MissingPhotosPopup } from 'features/cart/components/MissingPhotosPopup'
import { SCREENS } from 'services/Analytics/Analytics'
import type { PhotoBookCartItem } from 'stores/cartStore/CartItem'
import { MIN_PHOTO_BOOK_PAGES } from '@mixtiles/web-backend-shared'
import * as S from './InsufficientPhotosPopup.styles'

const SCREEN_CONFIG = {
  cart: {
    titleKey: 'photo_book.not_enough_photos.cart_title',
    analyticsSource: SCREENS.CART_DRAWER,
  },
  editor: {
    titleKey: 'photo_book.not_enough_photos.title',
    analyticsSource: SCREENS.PHOTO_BOOKS_DESIGNER,
  },
}

export function InsufficientPhotosPopup({
  open,
  screen,
  book,
  onDismiss,
  onApprove,
}: {
  open: boolean
  screen: keyof typeof SCREEN_CONFIG
  book: PhotoBookCartItem
  onDismiss: () => void
  onApprove: () => void
}) {
  const { t } = useTranslation()
  const { titleKey, analyticsSource } = SCREEN_CONFIG[screen]
  const { size, pageCount, photosCount } = book.metadata

  return (
    <MissingPhotosPopup
      open={open}
      popupName="Insufficient Photos"
      thumbnail={
        <S.BookCover
          data-testid="insufficient-photos-book-cover"
          data-book-id={book.id}
        >
          <BookThumbnail item={book} />
        </S.BookCover>
      }
      title={t(titleKey)}
      subtitle={t('photo_book.not_enough_photos.subtitle', {
        totalAmount: MIN_PHOTO_BOOK_PAGES,
        missingAmount: MIN_PHOTO_BOOK_PAGES - photosCount,
      })}
      ctaText={t('photo_book.not_enough_photos.cta')}
      analyticsProps={{
        Source: analyticsSource,
        'Book ID': book.id,
        'Book Size': size,
        'Page Count': pageCount,
        'Photo Count': photosCount,
      }}
      onDismiss={onDismiss}
      onApprove={onApprove}
    />
  )
}
